import { Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { PlatformService } from './platform.services';
import { CookieAttributes, getJSON, remove, set } from 'js-cookie';

export interface ICookieService {
  cookies$: Observable<{ [key: string]: any }>;
  getAll(): any;
  get(name: string): any;
  set(name: string, value: any, options?: CookieAttributes): void;
  remove(name: string, options?: CookieAttributes): void;
}
export class CookieService implements ICookieService {
private cookieSource = new Subject<{ [key: string]: any }>();
public cookies$ = this.cookieSource.asObservable();
public req: any;
/**
 * @param {?} platformService
 * @param {?} injector
 */
constructor(
private platformService: PlatformService,
private injector: Injector,
  ) {
    if (this.platformService.isServer) {
      this.req = this.injector.get('srvRequest');
    }
  }
/**
 * @param {?} name
 * @param {?} value
 * @param {?=} options
 * @return {?}
 */
public set(name: string, value: any, options?: CookieAttributes): void {
    if (this.platformService.isBrowser) {
      set(name, value, options);
      this.updateSource();
    }
  }
/**
 * @param {?} name
 * @param {?=} options
 * @return {?}
 */
public remove(name: string, options?: CookieAttributes): void {
    if (this.platformService.isBrowser) {
      remove(name, options);
      this.updateSource();
    }
  }
/**
 * @param {?} name
 * @return {?}
 */
public get(name: string): any {
    if (this.platformService.isBrowser) {
      return getJSON(name);
    } else {
      try {
        return JSON.parse(this.req.cookies[name]);
      } catch ( /** @type {?} */exception) {
        return this.req ? this.req.cookies[name] : undefined;
      }
    }
  }
/**
 * @return {?}
 */
public getAll(): any {
    if (this.platformService.isBrowser) {
      return getJSON();
    } else {
      if (this.req) return this.req.cookies;
    }
  }
/**
 * @return {?}
 */
private updateSource() {
    this.cookieSource.next(this.getAll());
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PlatformService, },
{type: Injector, },
];
}

function CookieService_tsickle_Closure_declarations() {
/** @type {?} */
CookieService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CookieService.ctorParameters;
/** @type {?} */
CookieService.prototype.cookieSource;
/** @type {?} */
CookieService.prototype.cookies$;
/** @type {?} */
CookieService.prototype.req;
/** @type {?} */
CookieService.prototype.platformService;
/** @type {?} */
CookieService.prototype.injector;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
